import React ,{useContext} from 'react';
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie';
import { getCookie, getLocalStorageItem } from '../utils/Utils';
import { AuthContext } from '../Context/authContext';

const IdealTimer= ({stayLoggedIn , logout})=>{
  const { t } = useTranslation();
  const { sendEvent } = useContext(AuthContext);

  const handleSignout = () => {
    const tokenId = getCookie('idcs_id_token');
    const roleCookie = getCookie('role');
    const roleStorage = getLocalStorageItem('role');
    const role = roleCookie || roleStorage;
    sendEvent("LOGOUT");
    // Clear local storage and cookies, then redirect to logout URL
    localStorage.clear()
    sessionStorage.clear()
    Cookies.remove('idcs_user_assertion', { path: '/' });
    Cookies.remove('idcs_refresh_token', { path: '/' });
    Cookies.remove('idcs_id_token', { path: '/' });
    Cookies.remove('role', { path: '/' });
    const LogoutURLDev = `${process.env.REACT_APP_ANOTHER_API_URL}/logout?port=${window.location.port}&role=${role}&token-id=${tokenId}`
    const LogoutOther = `${process.env.REACT_APP_ANOTHER_API_URL}/logout?role=${role}&token-id=${tokenId}`
    const API_BASE_URL =
      process.env.NODE_ENV === "development" ? LogoutURLDev : LogoutOther
    
    setTimeout(() => {
      window.location.href = API_BASE_URL
    }, 1000)
  }

  const { sessionExpiry, sessionExpirySubText, continueSessionText } = t('sessionExpirationPage')

  return(
    <div className="session-popup-overlay">
    <div className="session-popup">
      <h3 className='text-xl font-medium'>{sessionExpiry}</h3>
      <p className ='mt-4'>{sessionExpirySubText} </p>
      <p >{continueSessionText}</p>

      <div className="button-group">
        <button onClick={stayLoggedIn}>Stay Logged In</button>
        <button onClick={handleSignout}>Logout</button>
      </div>
    </div>
  </div>
  )
}
export default IdealTimer
